import { render, staticRenderFns } from "./scoreDetail.vue?vue&type=template&id=0b6563fd&scoped=true&"
import script from "./scoreDetail.vue?vue&type=script&lang=js&"
export * from "./scoreDetail.vue?vue&type=script&lang=js&"
import style0 from "./scoreDetail.vue?vue&type=style&index=0&id=0b6563fd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6563fd",
  null
  
)

export default component.exports